<template>
<v-container container--fluid>
    <v-layout align-center justify-center>
        <v-flex xs12 sm12 md10>
            <v-card class="elevation-12">
                <v-toolbar flat dark color="primary">
                    <v-toolbar-title>Forgot Username</v-toolbar-title>
                </v-toolbar>
                <v-card-text>
                    <v-alert v-model.trim="alert" outlined transition="scale-transition" dismissible type="success">Email Sent Successfully</v-alert>
                    <v-form class="overwrite-inputs" ref="pwdform" v-model.trim="valid" lazy-validation>
                        <v-text-field label="Email*" prepend-icon="email" v-model.lazy.trim="email" v-validate="'required|email'" :error="authErrors.has('email') || errors.has('email')" :error-messages="authErrors.get('email') || errors.collect('email')" data-vv-name="email"></v-text-field>
                    </v-form>
                </v-card-text>
                <v-card-actions class="pb-4">
                    <v-btn @click="clear" color="warning" :disabled="loginLoading" class="text-left">clear<v-icon right>clear</v-icon></v-btn>
                    <v-btn :loading="loginLoading" :disabled="!valid" color="primary" @click="sendUsernameEmail" class="text-left">Send Username<v-icon right>send</v-icon></v-btn>
                </v-card-actions>
                <v-divider light></v-divider>
                <v-card-text>
                    <div class="text-center pt-2">
                        <span color="gray--text">Already have an account?</span> <router-link :to="{ name: 'login' }">Login</router-link>
                    </div>
                </v-card-text>
            </v-card>
        </v-flex>
    </v-layout>
</v-container>
</template>

<script>
export default {
    data(){
        return {
            action: 'username-email',
            email: '',
            valid: true,
            alert: false,
            dictionary: {
                messages:{
                  required: () => 'This field is required',
                  email: () => 'This field must be a valid email',
                }
            },
        }
    },
    computed: {
        authErrors(){
            return this.$store.getters['auth/authErrors'];
        },
        loginLoading(){
            return this.$store.getters['auth/authStatus'] == 'loading';
        }
    },
    methods: {
        clear () {
            this.alert = false;
            this.$refs.pwdform.reset();
            this.$store.dispatch('auth/clearErrors');
        },
        sendUsernameEmail: function () {
            this.$validator.validate().then(valid => {
                if (valid) {
                    this.valid = false;
                    const { action, email} = this;
                    this.$store.dispatch('auth/sendUsernameEmail', { action, email })
                    .then((resp) => {
                        // console.log(resp);
                        this.alert = true;
                        var _self = this;

                        setTimeout(function(){
                            _self.$router.push({ name: 'home'});
                        }, 3000);
                    })
                    .catch((err) => {
                        this.valid = true;
                        // console.log(err);
                    });
                }
            });
        }
    },
    mounted () {
        this.$validator.localize('en', this.dictionary)
    },
}
</script>
